import { Toaster } from "@loot-os/ui/components/sonner";

import { useThemeStore } from "../lib/theme";

/** The app's toast outlet, in the theme on <html>, so an open toast restyles when it changes. */
export function ThemedToaster() {
  const theme = useThemeStore((s) => s.resolved);
  return <Toaster theme={theme} />;
}
